import React from 'react';
import PropTypes from 'prop-types';

const DesignGalleryItem = ({ imageSources, alt, title, designUrl }) => (
    <div className="mediabox mediabox--linked">
        <a
            className="mediabox__media-frame mediabox__media-frame--fullscreen"
            href={designUrl}
            rel="nofollow"
            style={{
                paddingBottom: '100%',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <picture
                style={{
                    position: 'absolute',
                    display: 'block',
                    height: '100%',
                    width: '100%',
                }}
            >
                <source
                    srcSet={`${imageSources.webpSrcSet}, ${imageSources.webpSrcSet2x} 2x`}
                    type="image/webp"
                    media="(min-width: 600px)"
                />
                <source
                    srcSet={`${imageSources.imageSrc}, ${imageSources.imageSrcSet2x} 2x`}
                    type="image/jpeg"
                    media="(min-width: 600px)"
                />
                <source srcSet={imageSources.imageSrcLarge} type="image/webp" />
                <img
                    className="mediabox__media"
                    alt={alt}
                    title={title}
                    src={imageSources.imageSrcLarge}
                    data-profile-design
                />
            </picture>
        </a>
    </div>
);

DesignGalleryItem.defaultProps = {
    alt: '',
    title: '',
};

DesignGalleryItem.propTypes = {
    designUrl: PropTypes.string.isRequired,
    imageSources: PropTypes.shape({
        imageSrc: PropTypes.string.isRequired,
        imageSrcLarge: PropTypes.string.isRequired,
        imageSrcSet2x: PropTypes.string.isRequired,
        webpSrcSet: PropTypes.string.isRequired,
        webpSrcSet2x: PropTypes.string.isRequired,
    }).isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
};

export default DesignGalleryItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignGalleryItem.jsx